import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import LeadSource from "../../components/Admin/LeadSource"

const LdSource = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Lead Sources | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <LeadSource />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default LdSource
